import { IntlShape } from 'react-intl';
import {
  IconAbc,
  IconBraces,
  IconBrackets,
  IconCalendar,
  IconNumber123,
  IconQuestionMark,
  IconToggleLeft,
  TablerIcon,
} from '@rossum/ui/icons/tabler';
import { ElisColumnType } from '../types';

export const dataTypes = (
  intl: IntlShape
): Record<ElisColumnType, { icon: TablerIcon; label: string }> => {
  return {
    string: {
      icon: IconAbc,
      label: intl.formatMessage({
        id: 'features.datasets.settings.form.columnsSection.type.string',
      }),
    },
    number: {
      icon: IconNumber123,
      label: intl.formatMessage({
        id: 'features.datasets.settings.form.columnsSection.type.number',
      }),
    },
    date: {
      icon: IconCalendar,
      label: intl.formatMessage({
        id: 'features.datasets.settings.form.columnsSection.type.date',
      }),
    },
    object: {
      icon: IconBraces,
      label: intl.formatMessage({
        id: 'features.datasets.settings.form.columnsSection.type.object',
      }),
    },
    array: {
      icon: IconBrackets,
      label: intl.formatMessage({
        id: 'features.datasets.settings.form.columnsSection.type.array',
      }),
    },
    bool: {
      icon: IconToggleLeft,
      label: intl.formatMessage({
        id: 'features.datasets.settings.form.columnsSection.type.bool',
      }),
    },
    unknown: {
      icon: IconQuestionMark,
      label: intl.formatMessage({
        id: 'features.datasets.settings.form.columnsSection.type.unknown',
      }),
    },
  };
};
